import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal, Lines, SectionTag } from "../site/Motion";
import { IMG } from "../../lib/images";

const STATS = [
  { value: "45", unit: "km/h", label: "Velocità massima" },
  { value: "100", unit: "km*", label: "Autonomia dichiarata", prefix: "fino a" },
  { value: "6.45", unit: "kWh", label: "Capacità batteria" },
  { value: "3.5", unit: "h*", label: "Tempo di ricarica" },
];

export function Electric() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="elettrica" data-testid="electric-section" ref={ref} className="relative overflow-hidden border-t border-white/10 py-28 sm:py-40">
      <motion.div className="absolute inset-0" style={reduce ? {} : { y: imgY }}>
        <img src={IMG.electric} alt="Ricarica di un veicolo elettrico" className="h-[120%] w-full object-cover opacity-30" loading="lazy" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/80 to-ink" aria-hidden="true" />

      <div className="relative mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="11" label="Elettrica" />
        <h2 className="mt-10 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
          <Lines lines={["Plug into", "the city."]} stagger={0.15} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
        </h2>

        <div className="mt-16 grid grid-cols-2 gap-px bg-white/10 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className="group bg-ink/90 p-6 backdrop-blur-sm transition-colors duration-500 hover:bg-elevated sm:p-10">
              {s.prefix && <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{s.prefix}</p>}
              <p className="mt-1 font-mono text-5xl font-semibold tracking-tight text-white transition-colors duration-500 group-hover:text-swapa-yellow sm:text-6xl">
                {s.value}
                <span className="ml-1 text-base text-zinc-500">{s.unit}</span>
              </p>
              <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">{s.label}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12 grid gap-10 lg:grid-cols-2">
          <p className="max-w-xl text-base leading-relaxed text-zinc-400">
            Due batterie rimovibili con trolley integrato: le stacchi, le porti con te,
            le ricarichi da una normale presa domestica. A casa, in ufficio, ovunque.
          </p>
          <p className="max-w-xl text-xs leading-relaxed text-zinc-600">
            * Autonomia fino a 100 km misurata a 30 km/h senza climatizzazione. Tempo di ricarica
            di 3,5 ore in condizioni di temperatura specifiche. I valori reali variano in base a
            velocità, stile di guida, temperatura, carico e condizioni del percorso.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
